import React, { useEffect } from 'react';
import Message from '../../components/message/Message';
import { SegmentProps } from '../../state-machine/actions/segment';
import { useTranslation } from 'react-i18next';
import { Maybe } from 'graphql/jsutils/Maybe';
import { convertToCurrency } from '../../helpers/converters/converters';

type DebitCardErrorProps = SegmentProps & {
  onNext: any;
  decisionCode: Maybe<string> | undefined;
  ipAmount: string;
  showDetailedDebitSoftDeclineMessages: boolean;
};

const DebitCardError: React.FC<DebitCardErrorProps> = ({ onNext, decisionCode, ipAmount, showDetailedDebitSoftDeclineMessages, track, page }) => {
  const { t } = useTranslation();
  useEffect(() => {
    page('Debit Card Error');
    track('Continuing to debit card screen', { decisionCode: decisionCode });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleButtonClick = () => {
    onNext();
  };

  let body: string;

  const test = t(($) => $.error.debitCardErrorA3, { amount: convertToCurrency(ipAmount, 0) });

  switch (decisionCode) {
    case 'A3':
      body = t(($) => $.error.debitCardErrorA3, { amount: convertToCurrency(ipAmount, 0) });
      break;

    case 'A4':
      body = t(($) => $.error.debitCardErrorA4);
      break;

    case 'A5':
      body = t(($) => $.error.debitCardErrorA5);
      break;

    case 'A6':
      body = t(($) => $.error.debitCardErrorA6);
      break;

    case 'A7':
      body = t(($) => $.error.debitCardErrorA7);
      break;

    default:
      body = t(($) => $.error.debitCardErrorDefault);
  }
  if (showDetailedDebitSoftDeclineMessages)
    return (
      <Message
        heading={t(($) => $.error.debitCardErrorSpecificHeading)}
        body={body}
        buttonText={t(($) => $.pageDebitCard.updateCardButtonText)}
        buttonClick={handleButtonClick}
      />
    );

  return (
    <Message
      heading={t(($) => $.error.debitCardGenericErrorHeading)}
      body={t(($) => $.error.debitCardGenericErrorBody)}
      buttonText={t(($) => $.buttonLabels.continue)}
      buttonClick={handleButtonClick}
    />
  );
};

export default DebitCardError;
